import React, { useEffect, useState } from "react";
import { askGet } from "../../utils/ask/askRequest";
import { BdResearchTemplate } from "../../types/bd/Bd";
import classes from "./assistant.module.scss";

/** Shown when BD settings has no templates or they can't be read (people without pages, offline). */
const BUILT_IN: BdResearchTemplate[] = [
    { name: "Salary benchmark", about: "Put pay figures from surveys and the cases you know side by side.", questions: ["Make a table of the salary figures in the attached files, one row per source."] },
    { name: "Compare quotes", about: "Line up provider quotes and see what stands out.", questions: ["Compare the attached quotes in a table: price per day, what's included, validity."] },
    { name: "Research a company", about: "What a company does, who runs it, how it fits our services.", questions: ["Brief me on "] },
];

interface AskStartProps {
    /** Put the card's first question in the box and focus it. */
    onPick: (question: string) => void;
}

/** The full page's empty state: what are you working on, and three ways to start. */
const AskStart: React.FC<AskStartProps> = ({ onPick }) => {
    const [templates, setTemplates] = useState<BdResearchTemplate[]>(BUILT_IN);
    useEffect(() => {
        let isLive = true;
        askGet("bd/research/templates").then((response) => {
            const rows = response.status === 200 && Array.isArray(response.body) ? (response.body as BdResearchTemplate[]).filter((t) => t.questions?.length) : [];
            if (isLive && rows.length) setTemplates(rows.slice(0, 3));
        }).catch(() => undefined);
        return () => { isLive = false; };
    }, []);
    return (
        <div className={classes.start}>
            <h2 className={classes.startTitle}>What are you working on?</h2>
            <p className={classes.para}>Ask about your work in CRX, a file, the web, or anything you&apos;d ask a colleague: write, translate, summarise, compare.</p>
            <div className={classes.startCards}>
                {templates.map((t) => (
                    <button key={t.name} type="button" className={`btn-unstyled ${classes.startCard}`} onClick={() => onPick(t.questions[0])}
                        title={`Start with: ${t.questions[0]}`}>
                        <b>{t.name}</b>
                        {t.about && <span className={classes.muted}>{t.about}</span>}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AskStart;
